import { render, staticRenderFns } from "./ClientBookingMenu.vue?vue&type=template&id=039ef44e"
import script from "./ClientBookingMenu.vue?vue&type=script&lang=js"
export * from "./ClientBookingMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports